export default "__VITE_ASSET__sUR2SmIm__"